import React, { useState, useEffect } from "react";
import axios from "axios";
import { useNavigate, useParams } from "react-router-dom";
import Layout from "./layout";
import { Container, Form, Button, Alert, Spinner, Card } from "react-bootstrap";

const EditProfile = () => {
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [nohp, setNohp] = useState("");
  const [alamat, setAlamat] = useState("");
  const [password, setPassword] = useState("");
  const [confPassword, setConfPassword] = useState("");
  const [foto, setFoto] = useState(null);
  const [role, setRole] = useState("");
  const [msg, setMsg] = useState("");
  const [successMsg, setSuccessMsg] = useState("");
  const [showSuccessAlert, setShowSuccessAlert] = useState(false); 
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();
  const { id } = useParams();

  useEffect(() => {
    const getUserById = async () => {
      const token = localStorage.getItem("token");
      try {
        const response = await axios.get(
          `https://c-greenproject.org:8000/users/${id}`,
          {
            headers: { Authorization: `Bearer ${token}` },
          }
        );
        const { name, email, role, additionalInfo } = response.data;
        setName(name);
        setEmail(email);
        setRole(role);
        setNohp(additionalInfo.nohp || "");
        setAlamat(additionalInfo.alamat || "");
      } catch (error) {
        setMsg("Error mendapatkan data pengguna.");
      }
    };
    getUserById();
  }, [id]);

  const updateUser = async (e) => {
    e.preventDefault();
    setMsg("");
    setSuccessMsg("");

    if (password && password !== confPassword) {
      setMsg("Password dan Konfirmasi Password tidak cocok.");
      return;
    }

    try {
      setIsLoading(true);
      const formData = new FormData();
      formData.append("name", name);
      formData.append("email", email);
      formData.append("nohp", nohp);
      formData.append("alamat", alamat);
      if (password) formData.append("password", password);
      if (confPassword) formData.append("confPassword", confPassword);
      if (foto) formData.append("foto", foto);
      const token = localStorage.getItem("token");

      await axios.patch(
        `https://c-greenproject.org:8000/users/${id}`,
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
            Authorization: `Bearer ${token}`,
          },
        }
      );

      setSuccessMsg("Profil berhasil diperbarui!");
      setShowSuccessAlert(true); 
      setTimeout(() => {
        navigate(`/profile-${role.toLowerCase()}`);
      }, 2000);
    } catch (error) {
      setMsg("Error saat memperbarui data.");
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <Layout>
      <Container className="mt-4">
        <h2 className="mb-3">
          <strong>Edit Profile: {role}</strong>
        </h2>

        {msg && (
          <Alert variant="danger" className="text-center">
            {msg}
          </Alert>
        )}

        {showSuccessAlert && (
          <Alert
            className="text-center custom-success-alert"
            dismissible
            onClose={() => setShowSuccessAlert(false)}
          >
            {successMsg}
          </Alert>
        )}

        <Card className="p-4 shadow-sm mb-3">
          <Form onSubmit={updateUser}>
            <Form.Group className="mb-3">
              <Form.Label>Nama</Form.Label>
              <Form.Control
                type="text"
                value={name}
                onChange={(e) => setName(e.target.value)}
                required
              />
            </Form.Group>

            <Form.Group className="mb-3">
              <Form.Label>Email</Form.Label>
              <Form.Control
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
              />
            </Form.Group>

            <Form.Group className="mb-3">
              <Form.Label>Nomor HP</Form.Label>
              <Form.Control
                type="text"
                value={nohp}
                onChange={(e) => setNohp(e.target.value)}
              />
            </Form.Group>

            <Form.Group className="mb-3">
              <Form.Label>Alamat</Form.Label>
              <Form.Control
                type="text"
                value={alamat}
                onChange={(e) => setAlamat(e.target.value)}
              />
            </Form.Group>

            <Form.Group className="mb-3">
              <Form.Label>Password (opsional)</Form.Label>
              <Form.Control
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
              />
            </Form.Group>

            <Form.Group className="mb-3">
              <Form.Label>Konfirmasi Password</Form.Label>
              <Form.Control
                type="password"
                value={confPassword}
                onChange={(e) => setConfPassword(e.target.value)}
              />
            </Form.Group>

            <Form.Group className="mb-3">
              <Form.Label>Foto</Form.Label>
              <Form.Control
                type="file"
                onChange={(e) => setFoto(e.target.files[0])}
                accept="image/*"
              />
            </Form.Group>

            <Button
              type="submit"
              variant="success"
              className="w-100"
              disabled={isLoading}
            >
              {isLoading ? <Spinner animation="border" size="sm" /> : "Update"}
            </Button>
          </Form>
        </Card>
      </Container>
    </Layout>
  );
};

export default EditProfile;
